<script>

    import Moment from 'moment'
    import { replace } from 'svelte-spa-router'
    import { adminStore } from '../stores'
    import { isPermission } from '../$methods/permissions.methods'

    import View from '../$layouts/view.layout.svelte'
    import PageHeader from '../$components/page.header.svelte'
    import DateRangeNav from '../$components/date.range.nav.svelte'
    import UsersActive from '../statistics/component.users.active.svelte'
    import ShipmentsGenerated from '../statistics/component.shipments.generated.svelte'
    import ShipmentsSales from '../statistics/component.shipments.sales.svelte'
    import ShipmentsProfit from '../statistics/component.shipments.profit.svelte'
    import ShipmentsMargin from '../statistics/component.shipments.margin.svelte'
    import ShipmentsAverageTicket from '../statistics/component.shipments.average.ticket.svelte'
    import ShipmentsAverageCost from '../statistics/component.shipments.average.cost.svelte'
    import ShipmentsAverageDeliveryDays from '../statistics/component.shipments.average.delivery.days.svelte'
    import PickupsScheduled from '../statistics/component.pickups.scheduled.svelte'
    import ShipmentsCanceled from '../statistics/component.shipments.canceled.svelte'
    import ShipmentsClientsProfit from '../statistics/component.shipments.clients.profit.svelte'
    import ChargesUsers from './component.charges.users.svelte'
    import OverweightsMonths from './component.overweights.months.svelte'
    import ShipmentsEvolution from './component.shipments.evolution.svelte'
    import EventsFunnel from './component.events.funnel.svelte'
    import EventsActivity from './component.events.activity.svelte'
    import ShipmentsProviders from './component.shipments.providers.svelte'
    import ShipmentsMap from './component.shipments.map.svelte'
    import PartnerBalance from './component.partner.balance.svelte'

    if (!isPermission($adminStore, 'GraphicsView'))
        replace('/404')

    let dateStart = Moment().startOf('month').startOf('day').toDate()
    let dateEnd = Moment().endOf('month').endOf('day').toDate()

</script>

<style>
    .toolbar {
        display: flex;
        justify-content: flex-end;
        margin-bottom: 1rem;
    }
</style>

<View>
    <PageHeader title="Gráficas" subtitle="Estadísticas y métricas de la plataforma" />

    <div class="toolbar">
        <DateRangeNav bind:dateStart bind:dateEnd />
    </div>

    <div class="columns is-multiline">
        <div class="column">
            <PartnerBalance partner="drenvio" />
        </div>
        <div class="column">
            <PartnerBalance partner="skydropx" />
        </div>
        <div class="column">
            <PartnerBalance partner="t1envios" />
        </div>
        <div class="column">
            <PartnerBalance partner="pak2go" />
        </div>
        <div class="column">
            <PartnerBalance partner="manuable" />
        </div>
    </div>

    <div class="columns is-multiline">
        <div class="column is-one-fifth">
            <UsersActive { dateStart } { dateEnd } />
        </div>
        <div class="column is-one-fifth">
            <ShipmentsGenerated { dateStart } { dateEnd } />
        </div>
        <div class="column is-one-fifth">
            <ShipmentsSales { dateStart } { dateEnd } />
        </div>
        <div class="column is-one-fifth">
            <ShipmentsProfit { dateStart } { dateEnd } />
        </div>
        <div class="column is-one-fifth">
            <ShipmentsMargin { dateStart } { dateEnd } />
        </div>
    </div>

    <div class="columns is-multiline">
        <div class="column is-6">
            <ShipmentsEvolution { dateStart } { dateEnd } />
        </div>
        <div class="column is-6">
            <EventsFunnel { dateStart } { dateEnd } />
        </div>
    </div>

    <div class="columns is-multiline">
        <div class="column is-5">
            <ShipmentsProviders { dateStart } { dateEnd } />
        </div>
        <div class="column is-7">
            <ShipmentsMap { dateStart } { dateEnd } />
        </div>
    </div>

    <div class="columns is-multiline">
        <div class="column is-12">
            <EventsActivity { dateStart } { dateEnd } />
        </div>
    </div>

    <div class="columns is-multiline">
        <div class="column is-12">
            <ShipmentsClientsProfit { dateStart } { dateEnd } />
        </div>
    </div>

    <div class="columns is-multiline">
        <div class="column is-12">
            <OverweightsMonths { dateStart } { dateEnd } />
        </div>
    </div>

    <div class="columns is-multiline">
        <div class="column is-12">
            <ChargesUsers { dateStart } { dateEnd } />
        </div>
    </div>

    <div class="columns is-multiline">
        <div class="column is-one-fifth">
            <ShipmentsAverageTicket { dateStart } { dateEnd } />
        </div>
        <div class="column is-one-fifth">
            <ShipmentsAverageCost { dateStart } { dateEnd } />
        </div>
        <div class="column is-one-fifth">
            <ShipmentsAverageDeliveryDays { dateStart } { dateEnd } />
        </div>
        <div class="column is-one-fifth">
            <PickupsScheduled { dateStart } { dateEnd } />
        </div>
        <div class="column is-one-fifth">
            <ShipmentsCanceled { dateStart } { dateEnd } />
        </div>
    </div>
</View>
